require('./app/menu');
require('./app/header');
require('./app/footer');
require('./app/posts-filter');
require('./app/cookies-msg');

// no longer needed as forms are being handled by hubspot. Leave for now,
// client may change mind.
//require('./app/contact');
